import React from 'react';
import classnames from 'classnames';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { IconButton, makeStyles } from '@material-ui/core';

const styles = makeStyles(({ palette }) => ({
  root: {
    color: palette.error.main,
  },
}));

interface RemoveButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
}

const RemoveButton = ({ onClick, label = 'remove', className = '' }: RemoveButtonProps) => {
  const classes = styles();
  const buttonClass = classnames({ [className]: !!className }, classes.root);

  return (
    <IconButton onClick={onClick} className={buttonClass} size="small" aria-label={label}>
      <DeleteOutlineIcon />
    </IconButton>
  );
};

export default RemoveButton;
